import React, { useEffect, useState } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { Caption, useWorkOrderStyles, Value } from "../workOrderDetails";
import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";

export const useStyles = makeStyles({
    container: {
        borderBottom: "1px solid #D4D4D4",
        borderTop: "1px solid #D4D4D4",
        paddingTop: "25px",
    },
    divarea: {
        width: "100%",
        border: "0px",
        whiteSpace: "pre-wrap",
        color: "var(--text-dark)",
        fontFamily: "Arial",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "16.1px",
    },
});

const WorkPermitDetails = ({ row }) => {
    const classes = useWorkOrderStyles();
    const cssClass = useStyles();
    const [permitStatus, setPermitStatus] = useState(null);
    const intl = useIntl();

    const formatDate = (date) => {
        if (!date) return "";

        return moment.utc(date).format("MMM DD, YYYY");
    };

    useEffect(() => {
        if (row) {
            switch (row.status?.id) {
                case 60:
                    row.statusName_en = "Requested";
                    row.statusName_fr = "Demandé";
                    setPermitStatus(row[`statusName_${intl.locale}`]);
                    return;
                case 61:
                    row.statusName_en = "Received";
                    row.statusName_fr = "Reçu";
                    setPermitStatus(row[`statusName_${intl.locale}`]);
                    return;
                default:
                    row.statusName_en = "";
                    row.statusName_fr = "";
                    setPermitStatus(row[`statusName_${intl.locale}`]);
                    return;
            }
        }
    }, [row]);

    return (
        <Grid container className={cssClass.container}>
            <Grid container className={classes.row}>
                <Grid item xs={2}>
                    <Caption>
                        <FormattedMessage
                            id="admin.work-order-details.wo-info.permit-details-title-permit-number-header"
                            defaultMessage="Permit Number"
                            description="Admin work order permit number column header"
                        />
                    </Caption>
                    <Value>{row.permitNumber}</Value>
                </Grid>
                <Grid item xs={2}>
                    <Caption>
                        <FormattedMessage
                            id="admin.work-order-details.wo-info.permit-details-title-requested-header"
                            defaultMessage="Requested"
                            description="Admin work order permit requested column header"
                        />
                    </Caption>
                    <Value>{row.requestedDate && formatDate(row.requestedDate)}</Value>
                </Grid>
                <Grid item xs={2}>
                    <Caption>
                        <FormattedMessage
                            id="admin.work-order-details.wo-info.permit-details-title-received-header"
                            defaultMessage="Received"
                            description="Admin work order permit received column header"
                        />
                    </Caption>
                    <Value>{row.receivedDate && formatDate(row.receivedDate)}</Value>
                </Grid>
                <Grid item xs={2}>
                    <Caption>
                        <FormattedMessage
                            id="admin.work-order-details.wo-info.permit-details-title-expires-header"
                            defaultMessage="Expires"
                            description="Admin work order permit expires column header"
                        />
                    </Caption>
                    <Value>{row.expirationDate && formatDate(row.expirationDate)}</Value>
                </Grid>
                <Grid item xs={1}>
                    <Caption>
                        <FormattedMessage
                            id="admin.work-order-details.wo-info.permit-details-title-status-header"
                            defaultMessage="Status"
                            description="Admin work order permit status column header"
                        />
                    </Caption>
                    <Value>{permitStatus}</Value>
                </Grid>
                <Grid item xs={1}>
                    <Caption>
                        <FormattedMessage
                            id="admin.work-order-details.wo-info.permit-details-title-cost-header"
                            defaultMessage="Cost"
                            description="Admin work order permit cost column header"
                        />
                    </Caption>
                    <Value>{row.cost ? "$" + row.cost : ""}</Value>
                </Grid>
                <Grid item xs={2}>
                    <Caption>
                        <FormattedMessage
                            id="admin.work-order-details.wo-info.permit-details-title-invoice-header"
                            defaultMessage="Invoice"
                            description="Admin work order permit invoice column header"
                        />
                    </Caption>
                    <Value>{row.invoiceNumber}</Value>
                </Grid>
            </Grid>

            <Grid container className={classes.row}>
                <Grid item xs={12}>
                    <Caption>
                        <FormattedMessage
                            id="admin.work-order-details.wo-info.permit-details-title-comment-header"
                            defaultMessage="Comment"
                            description="Admin work order permit comment column header"
                        />
                    </Caption>
                    <div className={cssClass.divarea}>{row.remarks}</div>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default WorkPermitDetails;
